import { Brick, registerBrick } from 'olympe';

export default class ValidateVendorDetails extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} vendorName
     * @param {*} vendorAddress
     * @param {*} vendorCity
     * @param {*} vendorCountry
     * @param {*} vendorEmail
     * @param {*} vendorContact
     * @param {function()} forwardEvent
     * @param {function(boolean)} setAllFilled
    
     */
    update($, [vendorName, vendorAddress, vendorCity, vendorCountry, vendorEmail, vendorContact], [forwardEvent, setAllFilled]) {
        if (vendorName && vendorAddress && vendorCity && vendorCountry && vendorEmail && vendorContact) {
            setAllFilled(false);
        } else {
            setAllFilled(true);
        }

        forwardEvent();
    }
}

registerBrick('019951de7e7e3568c3e8', ValidateVendorDetails);
